<template>
  <section>
    <div class="box">
      <div class="box-content">
        <!-- form -->
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(createOrEdit)">
            <div class="margin-top-l">
              <div class="flex">
                <div class="flex-1">
                  <validation-provider
                    name="nome"
                    rules=""
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-field item group-input "
                      :class="{ errors: errors[0], disabled: isEdit }"
                      
                    >
                      Primeiro Nome
                      <input
                        type="text"
                        v-model="newContact.first_name"
                        placeholder="Nome"
                        :disabled="isEdit"
                      />
                      <span class="erros-alert">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </div>
                <div class="flex-1">
                  <validation-provider
                    name="nome"
                    rules=""
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-field item group-input "
                      :class="{ errors: errors[0], disabled: isEdit } "
                    >
                      Sobrenome
                      <input
                        type="text"
                        v-model="newContact.last_name"
                        placeholder="Nome"
                        :disabled="isEdit"
                      />
                      <span class="erros-alert">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="flex">
                <div class="flex-1">
                  <validation-provider
                    name="email"
                    rules=""
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-field item group-input "
                      :class="{ errors: errors[0], disabled: isEdit }"
                    >
                      Email
                      <input
                        type="text"
                        v-model="newContact.email"
                        placeholder="xxxx@gmail.com"
                        :disabled="isEdit"
                      />
                      <span class="erros-alert">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="flex">
                <div class="flex-1">
                  <validation-provider
                    name="phone"
                    rules=""
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-field item group-input"
                      :class="{ errors: errors[0], disabled: isEdit }"
                    >
                      Telefone
                      <input
                        type="text"
                        v-model="newContact.phone"
                        placeholder="Telefone"
                        :disabled="isEdit"
                      />
                      <span class="erros-alert">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </div>
                <div class="flex-1">
                  <validation-provider
                    name="source"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-field item group-input "
                      :class="{ errors: errors[0], disabled: isEdit }"
                    >
                      Origem
                      <input
                        type="text"
                        v-model="newContact.source"
                        :disabled="isEdit"
                        placeholder="Origem do contato"
                      />
                      <span class="erros-alert">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <!-- status -->
              <div>
                <div class="flex margin-top-s">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Status
                      <select class="input" v-model="newContact.status">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in listStatus"
                          :key="k"
                          :value="v.value"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- contacts -->
              <div class="margin-top-l">
                <div class="flex margin-top-s">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Lista
                      <select class="input" v-model="addContactList">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in listsAccount"
                          :key="k"
                          :value="v"
                        >
                          {{ v.name }}
                        </option>
                      </select>
                      <div class="margin-top-s">
                        Listas do contato:
                      </div>
                      <div class="list-elements">
                        <ul>
                          <li v-for="(v, k) in newContact.lists" :key="k">
                            <div class="flex middle">
                              <div class="flex-1 ">
                                {{ v.name }}
                              </div>
                              <div class="flex-1 flex end">
                                <div @click="removeList(v)" class="remove">
                                  <b>X</b>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Tag
                      <select class="input" v-model="addContactTag">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v"
                        >
                          {{ v.name }}
                        </option>
                      </select>
                      <div class="margin-top-s">
                        Tags do contato:
                      </div>
                      <div class="list-elements">
                        <ul>
                          <li v-for="(v, k) in newContact.tags" :key="k">
                            <div class="flex middle">
                              <div class="flex-1">
                                {{ v.name }}
                              </div>
                              <div class="flex-1 flex end">
                                <div @click="removeTag(v)" class="remove">
                                  <b>X</b>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="margin-top-l actions">
              <router-link :to="{ name: 'Contact' }">
                <button class="button secondary">
                  Voltar
                </button>
              </router-link>

              <button class="button primary" type="submit">
                {{ isEdit ? 'Salvar Contato' :  'Criar Contato' }} 
              </button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </section>
</template>

<script>
import { 
  createContact,
  updateContact,
  getContact
} from "@/services/contact";

import { getTags } from "@/services/tag";

import { getLists } from "@/services/list";

export default {
  name: "contact-new",
  components: {},
  props: ["contact_id"],
  data() {
    return {
      newContact: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        source: "",
        status: "ACTIVE",
        custom_fields: {},
        tags: [],
        lists: [],
        tags_to_add: [],
        lists_to_add: [],
        tags_to_remove: [],
        lists_to_remove: [],
      },
      listStatus: [
        { label: 'ATIVO', value: 'ACTIVE' },
        { label: 'REMOVIDO (PELO LEAD)', value: 'REMOVED' },
        { label: 'REMOVIDO (PELO SCRIPT DE FALHA)', value: 'FAILURE' },
        { label: 'DESATIVADO', value: 'DISABLE' },
      ],
      addContactTag: "",
      addContactList: "",
      listsAccount: [],
      tagsAccount: [],
      templateList: [],
    };
  },
  mounted() {
    this.getTags();
    this.getLists();

    if (this.contact_id) {
      this.getContact();
    }
  },
  watch: {
    addContactTag(value) {
      if (value) {
        let check = this.newContact.tags.find((t) => t.id == value.id);
        if (!check) {
          this.newContact.tags.push(value);
          // controler to back
          this.newContact.tags_to_add.push(value);
        }

        this.addContactTag = "";
      }
    },
    addContactList(value) {
      if (value) {
        let check = this.newContact.lists.find((t) => t.id == value.id);
        if (!check) {
          this.newContact.lists.push(value);
          // controler to back
          this.newContact.lists_to_add.push(value);
        }

        this.addContactList = "";
      }
    },
  },
  computed: {
    isEdit() {
      return this.contact_id
    }
  },
  methods: {
    removeTag(tag) {
      this.newContact.tags = this.newContact.tags.filter((t) => t.id != tag.id);
      this.newContact.tags_to_remove.push(tag)
      
    },
    removeList(list) {
      this.newContact.lists = this.newContact.lists.filter(
        (t) => t.id != list.id
      );
      this.newContact.lists_to_remove.push(list)
    },
    getContact() {
      getContact(this.contact_id)
        .then((result) => {
          // adjust to have list to operations
          this.newContact = Object.assign({
            tags_to_add: [],
            lists_to_add: [],
            tags_to_remove: [],
            lists_to_remove: [],
          }, result);
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao buscar contact",
          });
        });
    },
    createOrEdit() {
      if (this.isEdit) {
        this.updateContact()
      } else {
        this.createContact()
      }
    },
    createContact() {
      let params = this.newContact;

      createContact(params)
        .then(() => {
          this.$router.push({ name: "Contact" });

          this.$toast.success({
            title: "Sucesso",
            message: "Contact criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateContact() {
      let params = this.newContact;

      updateContact(this.contact_id, params)
        .then(() => {
          this.$router.push(0);

          this.$toast.success({
            title: "Sucesso",
            message: "Contact editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    getTags() {
      this.getTags = [];
      getTags()
        .then((result) => {
          this.tagsAccount = result.map((r) => {
            return { id: r.id, name: r.name };
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao buscar dados",
          });
        });
    },
    getLists() {
      getLists()
        .then((result) => {
          this.listsAccount = result.map((r) => {
            return { id: r.id, name: r.name };
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao buscar dados",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>

.disabled {
  input {
    background: #f0f0f0;
  }
}

.contacts {
  padding-left: 8px;
}
.p-8 {
  padding: 0px 8px;
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 1030px;
  min-width: 1030px;
  min-height: 200px;
  max-height: 200px;
}

.active {
  background: var(--primary) !important;
  color: #fff !important;
}

.actions {
  padding: 0px 8px;
  * {
    margin-right: 8px;
  }
}

.list-elements {
  margin-top: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 4px 8px;
  max-height: 200px;
  overflow-y: scroll;
  ul {
    list-style: none;
    li {
      padding: 2px 4px;
      border-bottom: 1px solid #ccc;
      .tag {
        background: #c2c2c2;
        padding: 4px 6px;
        border-radius: 5px;
        font-size: 11px;
        font-weight: 800;
        margin-left: 8px;
      }
      .button {
        margin-left: 4px;
      }
    }
  }
}
.remove {
  padding: 8px;
  cursor: pointer;
}
</style>

<style lang="scss">
.mx-datepicker {
  .mx-input-wrapper {
    .mx-input {
      height: 50px;
    }
  }
  // fix icon
  svg {
    margin-top: 10px;
  }
}
</style>
